import EnumClass, { build } from '../EnumClass';
import data, { AliasTimezonesId, AliasTimezonesData } from './data';
import * as Translations from './translations';

export class AliasTimezones extends EnumClass<AliasTimezonesId, AliasTimezonesData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: ALIAS_TIMEZONES,
  getById: getAliasTimezonesById,
  marshaller: AliasTimezonesMarshaller,
  codec: AliasTimezonesCodec,
} = build<AliasTimezonesId, AliasTimezonesData, AliasTimezones>('AliasTimezonesEnum', data, AliasTimezones);
